export default __webpack_public_path__ + "static/media/Artificial Intelligence.4c500a6b.pdf";